// src/data/popularServices.js
// Auto-generated from services.json — edit to add/remove services
// rules array = all domains to block/unblock for this service

import servicesData from './services.json';

// Group display config
export const GROUP_CONFIG = {
    social_network: { label: 'Social Networks',      icon: '👥' },
    streaming:      { label: 'Streaming & Video',    icon: '📺' },
    gaming:         { label: 'Gaming',               icon: '🎮' },
    messenger:      { label: 'Messaging',            icon: '💬' },
    shopping:       { label: 'Shopping',             icon: '🛍️' },
    dating:         { label: 'Dating',               icon: '❤️' },
    gambling:       { label: 'Gambling',             icon: '🎰' },
    ai:             { label: 'Artificial Intelligence', icon: '🤖' },
    cdn:            { label: 'CDN & Infrastructure', icon: '🌐' },
    privacy:        { label: 'VPN & Privacy',        icon: '🔒' },
    software:       { label: 'Software & Tools',     icon: '💻' },
    hosting:        { label: 'Hosting & Cloud',      icon: '☁️' },
};

// Parse rules: "||youtube.com^" → "youtube.com"
export function parseRule(rule) {
    return rule
        .replace(/^\|\|/, '')   // remove leading ||
        .replace(/\^.*$/, '')   // remove ^ and anything after
        .replace(/\$.*$/, '');  // remove $ filters
}

// Build categories from services.json grouped by group
export function buildPopularCategories() {
    const grouped = {};

    servicesData.blocked_services.forEach(service => {
        const group = service.group || 'other';
        if (!grouped[group]) grouped[group] = [];

        grouped[group].push({
            id: service.id,
            name: service.name,
            icon_svg: service.icon_svg,
            // All domains for this service — used when blocking/unblocking
            rules: service.rules.map(parseRule),
            // Display URL (first clean domain)
            url: parseRule(service.rules[0]),
            // Favicon from first domain
            favicon: `https://www.google.com/s2/favicons?domain=${parseRule(service.rules[0])}&sz=32`,
            blocked: false,  // default — will be synced from DB
            _id: null,       // will be populated from DB
            _dbIds: [],      // array of DB _ids for all rules of this service
        });
    });

    // Build array in preferred group order
    const groupOrder = ['social_network', 'streaming', 'gaming', 'messenger', 'shopping', 'dating', 'gambling', 'ai', 'privacy', 'software', 'cdn', 'hosting'];

    return groupOrder
        .filter(g => grouped[g])
        .map(g => ({
            name: GROUP_CONFIG[g]?.label || g,
            icon: GROUP_CONFIG[g]?.icon || '🌐',
            groupId: g,
            sites: grouped[g],
        }));
}